import clsx from 'clsx'
import {
  FileTextIcon
} from 'lucide-react'

import {
  IconLink,
  TextLink
} from 'slab'

import { CarrierLogo } from '../../members/components/CarrierLogo'
import { OnboardingMetalTierBadge } from '../components/OnboardingMetalTierBadge/OnboardingMetalTierBadge'
import { PlanBadge } from '../components/PlanBadge/PlanBadge'
import { type MedicalPlanDisplayItem } from '../medicalPlanTypes'

interface MedicalPlanDetailHeaderProps {
  plan: MedicalPlanDisplayItem['plan'];
  planYear?: number;
  iconOnly?: boolean;
}

export function MedicalPlanDetailHeader ({ plan, planYear, iconOnly = false }: MedicalPlanDetailHeaderProps) {
  const SbcLink = ({ sbcUrl }: { sbcUrl?: string }) => {
    if (!sbcUrl) {
      return (
        <div className='shrink-0 text-gray-500 body'>
          SBC coming soon
        </div>
      )
    }

    if (!iconOnly) {
      return (
        <div className='shrink-0'>
          <TextLink
            color='gray'
            leftIcon={FileTextIcon}
            href={sbcUrl}
            target='_blank'
          >
            Summary of Benefits
          </TextLink>
        </div>
      )
    }

    return (
      <div className='shrink-0 ml-auto'>
        <IconLink
          color='gray'
          icon={FileTextIcon}
          href={sbcUrl}
          target='_blank'
          label='Summary of Benefits'
        />
      </div>
    )
  }

  return (
    <div className='flex gap-x-4 mb-6 w-full'>
      {plan.carrier_image_url && plan.carrier_image_url.length > 0 && (
        <CarrierLogo aria-hidden size='large' src={plan.carrier_image_url} />
      )}
      <div className={clsx('flex flex-row gap-4 justify-between w-full', {
        'items-start': iconOnly,
        'flex-wrap': !iconOnly
      })}
      >
        <div className={clsx('flex flex-col gap-y-1', {
          'flex-1 min-w-0': iconOnly
        })}
        >
          <div className='flex flex-col xs:flex-row justify-between'>
            <div className='flex flex-col xs:flex-row gap-2 justify-start items-start flex-wrap'>
              <h1 className='heading-md xs:heading-lg text-gray-800'>
                {plan.friendly_name}
              </h1>
              <div className='flex h-8 gap-x-2 items-center'>
                <OnboardingMetalTierBadge tier={plan.metal_tier} />
                <PlanBadge type={plan.plan_type} />
              </div>
            </div>
          </div>
          <div className='body text-gray-500'>
            <span data-testid='details-carrier-name'>{plan.carrier_name}</span>
            {planYear && (
              <span data-testid='details-plan-year' className='body-bold text-gray-800'>
                {' '}({planYear})
              </span>)}
          </div>
        </div>
        <SbcLink sbcUrl={plan.sbc_url} />
      </div>
    </div>
  )
}
